import { memo, useEffect, useState } from 'react';
import { AppBar, Tabs } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import _startsWith from 'lodash/startsWith';
// Local files
import { LogoContainer, StyledTab, StyledToolbar } from './AppNavigation.styled';
import logo from 'assets/images/logo.svg';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import AccountMenu from './AccountMenu/AccountMenu';

const AppNavigation = () => {
  const { pathname } = useLocation();
  const [tab, setTab] = useState('dashboard');

  useEffect(() => {
    _startsWith(pathname, '/dashboard') && setTab('dashboard');
    _startsWith(pathname, '/patients') && setTab('patients');
    _startsWith(pathname, '/users') && setTab('users');
    _startsWith(pathname, '/locations') && setTab('locations');
    _startsWith(pathname, '/providers') && setTab('providers');
    _startsWith(pathname, '/settings') && setTab('/');
  }, [pathname]);

  return (
    <AppBar position='static' color='transparent' elevation={0}>
      <StyledToolbar>
        <LogoContainer src={logo} alt='converse-health' />
        <Tabs
          variant="scrollable"
          value={tab}
          onChange={(_, newValue) => setTab(newValue)}
          sx={{ pr: { xs: 'unset', md: '142px' } }}
        >
          <StyledTab component={NavLink} to='/dashboard' value='dashboard' label='Dashboard' />
          <StyledTab component={NavLink} to='/patients' value='patients' label='Patients' />
          <StyledTab component={NavLink} to='/users' value='users' label='Users' />
          <StyledTab component={NavLink} to='/locations' value='locations' label='Locations' />
          <StyledTab component={NavLink} to='/providers' value='providers' label='Providers' />
        </Tabs>
        <AccountMenu />
      </StyledToolbar>
    </AppBar>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <AppNavigation {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);